module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image7b.db9c0b60.webp";